import { HttpRequest, HttpErrorResponse, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { Observable, throwError, timer } from 'rxjs';

import { ErrorReportingService } from 'src/app/features/shared/error/error-reporting.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

export function httpErrorInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const _errorReporting = injectRequired(ErrorReportingService);
    // const _router = injectRequired(Router);
    // const _urlService = injectRequired(UrlService);

    const _maxNumberOfRetryNoConnection: number = 5;
    const _retryDelay: number = 500;

    // const _url = req.url;
    // const _checkedUrl = _urlService.checkUrl(_url);

    // if (_checkedUrl !== _url) {
    //     _router.navigate([_checkedUrl]);
    // }

    return next(request).pipe(
        retry({
            count: 2, 
            delay: (error: HttpErrorResponse, retryAttempt: number): Observable<number> => {
                // if maximum number of retries have been met
                // or response is a status code we don't wish to retry, throw error
                if (retryAttempt > _maxNumberOfRetryNoConnection || error.status !== 404) {
                    return throwError(() => error);
                }
                console.log(`Attempt ${retryAttempt}: retrying in ${retryAttempt * _retryDelay}ms`);
                // retry after 1s, 2s, etc...
                return timer(retryAttempt * _retryDelay);
            },
        }),
        catchError((err: HttpErrorResponse) => {
            _errorReporting.report(err);

            return throwError(() => err);
        })
    );
}
